import PickerModal, {
  IPickerModalProps
} from '@maxpreps/shared/corecomponents/PickerModal/PickerModal';
import dynamic from 'next/dynamic';
import React from 'react';
import useSeasonPickerProps from './useSeasonPickerProps';

interface ISeasonPickerProps {
  onClose: () => void;
}

const SeasonPicker: React.FC<ISeasonPickerProps> = ({ onClose }) => {
  const seasonPickerProps: Omit<IPickerModalProps, 'onClose'> =
    useSeasonPickerProps();
  return <PickerModal onClose={onClose} {...seasonPickerProps} />;
};

export default dynamic(() => Promise.resolve(SeasonPicker), { ssr: false });
